import * as React from 'react';

import { Notification } from '@coursera/coursera-ui';

import _t from 'i18n!nls/teams-v2';

type Props = {
  promotion: {
    discountPercent: number | null;
    promotionName: string;
  };
};

const InvalidPromotionBanner: React.FC<Props> = ({ promotion }) => {
  return (
    <Notification
      type="warning"
      message={_t('The #{percentage}% discount from #{name} is not available.', {
        percentage: promotion.discountPercent ?? 0,
        name: promotion.promotionName,
      })}
    />
  );
};

export default InvalidPromotionBanner;
